export const isAppleDevice = /iPad|iPhone|iPod/.test(navigator.userAgent);
